//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import {
    EmployeesCreate,
    EmployeesDetails,
    EmployeesList,
} from '@/views/HumanResource/HrEmployee'

//
export default {
    path: 'employees',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'employee-list',
            component: EmployeesList,
        },
        {
            path: 'new',
            name: 'employee-create',
            component: EmployeesCreate,
            meta: {
                title: 'Crear empleado',
            },
        },
        {
            path: ':id',
            name: 'employee-details',
            component: EmployeesDetails,
            meta: {
                title: 'Detalles del empleado',
            },
        },
    ],
    meta: {
        title: 'Empleados',
    },
}
